<template>
  <div class="w-290px h-full box-border flex flex-col bg-white overflow-hidden">
    <header
      class="mt-4 mb-2 pl-3 pr-4 box-border border-l-4 border-solid border-theme text-medium-x text-theme-black-850 font-semibold"
    >
      推送报告
    </header>
    <div class="flex-1 text-medium text-theme-black-850 leading-22 overflow-auto">
      <p class="mb-2 mx-4 text-justify">开启报告推送功能，答题人通过微信公众号获取答题报告。</p>
      <p class="mb-2 mx-4 text-justify">获取报告步骤：</p>
      <ul class="mx-4 flex flex-col" :class="showImg ? '' : 'mb-4'">
        <li class="mb-2 flex text-justify" v-for="st of steps" :key="st.orderNo">
          <div class="mr-2">{{st.orderNo}}.</div>
          <div class="flex-1">{{st.text}}</div>
        </li>
      </ul>
      <div class="mb-4 mx-4" v-if="showImg">
        <el-image
          class="w-full"
          :src="`${baseUrl}img/push_report_step_aside.png`"
          style="height: 66px"
        ></el-image>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PushReportAside',
  props: {
    showImg: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      steps: [
        { orderNo: 1, text: '在问卷中添加手机号相关题目，将问卷发送给答题人；' },
        { orderNo: 2, text: '答题人答题，提交答卷；' },
        { orderNo: 3, text: '下载微信公众号二维码，发送给答题人；' },
        { orderNo: 4, text: '答题人扫码关注公众号，关注后，回复关键词 “1” 将获取到报告链接，点击【查看报告】，即可查看本次答题情况。' }
      ]
    }
  }
}
</script>